import React from "react";

// Mui Styles
import { ThemeProvider } from "@mui/material/styles";
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import Layout from "@/components/layout";
import Title from "@/components/title";
import DataTable from "@/components/dataTable";

// Fetch
import { getAllLandingPage } from "@/fetch/fetchOffice";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

// Config
import { LandingTableColumn } from "@/config/tableColumnConfig";

const LandingSettingPage = (props) => {
  const { open, setOpen } = props;

  // Navigate
  const navigate = useNavigate();

  const onClickCreate = () => {
    navigate("create");
  };

  // States
  const [landingData, setLandingData] = React.useState([]);
  const [dataTableLoading, setDataTableLoading] = React.useState(false);

  const onCellClick = (data) => {
    navigate(`edit/${data.row.id}`);
  };

  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      await getAllLandingPage().then((data) => {
        if (data && data.results) {
          let tempArr = [...data.data];
          for (let i = 0; i < tempArr.length; i++) {
            if (tempArr[i].time_created) {
              tempArr[i].time_created = moment(tempArr[i].time_created).format(
                "YYYY-MM-DD"
              );
            }
            if (tempArr[i].title === null) {
              tempArr[i].title = "";
            }
            if (tempArr[i].bitlyfloating === null) {
              tempArr[i].bitlyfloating = "";
            }
            if (tempArr[i].bitlymannings === null) {
              tempArr[i].bitlyfloating = "";
            }
            if (tempArr[i].bitly3chembio === null) {
              tempArr[i].bitlyfloating = "";
            }
          }
          setLandingData(tempArr);
        }
      });
    } catch (error) {
    } finally {
      setDataTableLoading(false);
    }
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="LandingSettingPage"
      // snackOpen={snackOpen}
      // snackClose={() => setSnackOpen(false)}
      // snackMessage={snackMessage}
      selectedIndex={13}
      open={open}
      setOpen={setOpen}
    >
      <Title
        FunctionOn
        title="廣告頁"
        createName="新增廣告頁"
        // deleteName="刪除選擇項目"
        onClickCreate={() => onClickCreate()}
      />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={landingData}
            columns={LandingTableColumn}
            pageSize={10}
            onCellClick={(data) => onCellClick(data)}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default LandingSettingPage;
